/* ══════════════════════════════════════════════════════════════
   Regime Breakdown — P&L per Regime Bar Chart
   ══════════════════════════════════════════════════════════════ */

export interface RegimeStats {
    regime: string;
    trades: number;
    winRate: number;
    avgPnl: number;
    totalPnl: number;
    color: string;
}

export function renderRegimeBreakdown(container: HTMLElement, data?: RegimeStats[]): void {
    const stats: RegimeStats[] = data || [
        { regime: 'Trending Bull', trades: 20, winRate: 70, avgPnl: 1.5, totalPnl: 30, color: '#10b981' },
        { regime: 'Sideways/Range', trades: 18, winRate: 60, avgPnl: 0.4, totalPnl: 7.2, color: '#f59e0b' },
        { regime: 'Trending Bear', trades: 5, winRate: 40, avgPnl: -0.5, totalPnl: -2.5, color: '#ef4444' },
        { regime: 'High Volatility', trades: 5, winRate: 50, avgPnl: 0.2, totalPnl: 1.0, color: '#8b5cf6' },
    ];

    const maxPnl = Math.max(...stats.map(s => Math.abs(s.totalPnl)));

    const bars = stats.map(s => {
        const width = (Math.abs(s.totalPnl) / maxPnl * 100).toFixed(0);
        const isPos = s.totalPnl >= 0;
        return `
      <div class="regime-bar-row">
        <div class="regime-bar-label">
          <span class="regime-dot" style="background:${s.color}"></span>
          <span class="regime-name">${s.regime}</span>
        </div>
        <div class="regime-bar-container">
          <div class="regime-bar ${isPos ? 'positive' : 'negative'}" style="width:${width}%; background:${s.color}">
            <span class="bar-text">${isPos ? '+' : ''}${s.totalPnl.toFixed(1)}%</span>
          </div>
        </div>
        <div class="regime-bar-stats">
          <span>${s.trades} trades</span>
          <span>WR: ${s.winRate}%</span>
          <span>Avg: ${s.avgPnl >= 0 ? '+' : ''}${s.avgPnl}%</span>
        </div>
      </div>`;
    }).join('');

    container.innerHTML = `
    <div class="regime-breakdown glass-card">
      <div class="card-header"><h3>🎭 Regime Breakdown</h3></div>
      <div class="regime-bars">${bars}</div>
    </div>`;
}
